import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ApiPrefixes, UserRoleRepresentationDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '@workspace/ng-aura';
import { ApiService } from '@workspace/ng-http';
import { tap } from 'rxjs';

export interface UserRolesFormModel {
  roles: UserRoleRepresentationDto[];
}

@Component({
  selector: 'core-user-roles-form',
  templateUrl: './roles-form.component.html',
  imports: [FormField, MatFormFieldModule, MatSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserRolesFormAdminCoreComponent
  extends AbstractSignalFormComponent<UserRoleRepresentationDto[], UserRolesFormModel>
  implements OnInit
{
  private api = inject(ApiService);
  userRoleRepresentations = signal<UserRoleRepresentationDto[]>([]);

  override model: WritableSignal<UserRolesFormModel> = signal<UserRolesFormModel>({
    roles: [],
  });

  override formTree = form(this.model);

  ngOnInit(): void {
    this.getRoleRepresentations();
  }

  protected override buildModelFromDto(dto: UserRoleRepresentationDto[]): UserRolesFormModel {
    return {
      roles: dto ?? [],
    };
  }

  protected override buildDtoFromModel(model: UserRolesFormModel): UserRoleRepresentationDto[] {
    return model.roles;
  }

  getRoleRepresentations() {
    this.api
      .admin()
      .keycloak()
      .getClientRoles(ApiPrefixes.ADMIN)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((userRoles) => {
          if (userRoles) {
            this.userRoleRepresentations.set(userRoles);
          }
        }),
      )
      .subscribe();
  }

  compareRoles = (a: UserRoleRepresentationDto | null, b: UserRoleRepresentationDto | null): boolean => {
    return !!a && !!b && a.id === b.id;
  };
}
